import { useStoreon } from 'storeon/react';
import { IEvents, IState } from 'src/store';

import {
  roofTypeGambrelIcon, roofTypeHipIcon, roofTypeTentedIcon, roofTypeMultiPitchIcon, roofTypeGableIcon,
  roofTypeLamonteraGambrel, roofTypeLamonteraHip, roofTypeLamonteraTented, roofTypeLamonteraMultiPitch, roofTypeLamonteraGable,
  // roofTypeMontekristoGambrel, roofTypeMontekristoHip, roofTypeMontekristoTented, roofTypeMontekristoMultiPitch, roofTypeMontekristoGable,
  // roofTypeMonterossaGambrel, roofTypeMonterossaHip, roofTypeMonterossaTented, roofTypeMonterossaMultiPitch, roofTypeMonterossaGable,
  // roofTypeTramontaGambrel, roofTypeTramontaHip, roofTypeTramontaTented, roofTypeTramontaMultiPitch, roofTypeTramontaGable,
  // roofTypeMP20Gambrel, roofTypeMP20Hip, roofTypeMP20Tented, roofTypeMP20MultiPitch, roofTypeMP20Gable,
  // roofTypeS21Gambrel, roofTypeS21Hip, roofTypeS21Tented, roofTypeS21MultiPitch, roofTypeS21Gable,
} from 'src/assets/images';

import { StepType } from "src/store/RoofStoreModule";
import { RoofType } from "src/store/roofData/types";
import { useState } from 'react';

interface Roof {
  id: number;
  type: RoofType;
  img: string;
  imgBig: string;
  label: string;
}

export const roofCards: Roof[] = [
  {
    id: 1,
    type: 'gambrel',
    img: roofTypeGambrelIcon,
    imgBig: roofTypeLamonteraGambrel,
    label: 'Мансардная',
  },
  {
    id: 2,
    type: 'hip',
    img: roofTypeHipIcon,
    imgBig: roofTypeLamonteraHip,
    label: 'Вальмовая',
  },
  {
    id: 3,
    type: 'tented',
    img: roofTypeTentedIcon,
    imgBig: roofTypeLamonteraTented,
    label: 'Шатровая',
  },
  {
    id: 4,
    type: 'multipitch',
    img: roofTypeMultiPitchIcon,
    imgBig: roofTypeLamonteraMultiPitch,
    label: 'Многоскатная',
  },
  {
    id: 5,
    type: 'gable',
    img: roofTypeGableIcon,
    imgBig: roofTypeLamonteraGable,
    label: 'Двускатная',
  },
];

export const usePresenter = () => {
  const { dispatch, roofStore } = useStoreon<IState, IEvents>('roofStore');
  const [multipitchModalOpen, setMultipitchModalOpen] = useState(false);

  const chooseRoofType = (type: RoofType) => {
    if (type === 'multipitch') {
      setMultipitchModalOpen(true);
      return;
    }

    if (roofStore.roofType !== type) {
      dispatch('roof/set-roof-type', { value: type });
      dispatch('roof/set-L_kr-value', { value: null });
      dispatch('roof/set-L_k-value', { value: null });
      dispatch('roof/set-B_kr-value', { value: null });
      dispatch('roof/set-B_kr1-value', { value: null });
      dispatch('roof/set-B_kr2-value', { value: null });
      dispatch('roof/set-H_p1-value', { value: null });
      dispatch('roof/set-H_p2-value', { value: null });
    }

    dispatch('roof/set-stepID', { stepID: ((roofStore.stepID + 1) as StepType) });
  };

  return {
    roofCards,
    activeRoof: roofStore.roofType,
    chooseRoofType,
    multipitchModalOpen,
    setMultipitchModalOpen,
  };
};
